module.exports = __webpack_public_path__ + "static/media/06.45280a4e.mp3";